<template>
  <div class="center">
    <v-checkbox
      v-model="value"
      disabled
    />
  </div>
</template>

<script>
export default {
  name: 'DataTableCheckBoxColumn',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
